module.exports = __webpack_public_path__ + "eu.44b6e82bec795a2c2099.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/eu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/eu.svg
// module chunks = styles